var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field-money',{attrs:{"properties":_vm.vuetifyTextFieldProps,"options":{
    locale: _vm.browserLanguage,
    length: Infinity,
    precision: 0, // No decimals support. Change to 2 if decimals are allowed and implement correct formatting in the handleChange method.
    empty: 0,
  },"label":_vm.vuetifyTextFieldProps.label || ''},on:{"input":_vm.handleChange},model:{value:(_vm.humanizedValue),callback:function ($$v) {_vm.humanizedValue=$$v},expression:"humanizedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }